import { useEffect, useState } from 'react';
import { useLocale } from 'next-intl';

export default function useHostMatch(domain: string): boolean {
  const [isMatch, setIsMatch] = useState(false);
  const locale = useLocale();

  useEffect(() => {
    if (typeof window !== 'undefined' && locale === 'en') {
      setIsMatch(window.location.hostname === domain);
    }
  }, [domain]);

  return isMatch;
}
